export const Eye = ({ size = 20, className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle
        cx="9.9987"
        cy="10.0002"
        r="1.66667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3346 9.99984C16.1121 13.889 13.3346 15.8332 10.0013 15.8332C6.66797 15.8332 3.89047 13.889 1.66797 9.99984C3.89047 6.11067 6.66797 4.1665 10.0013 4.1665C13.3346 4.1665 16.1121 6.11067 18.3346 9.99984"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
